import React from 'react'
import ash from '../Images/ash-shrugged.png'


export default function FourOFour() {

    return (
        <div>
            <h1>The url was not found</h1>
            <img style={{height: "400px"}} src={ash} alt="Ash Ketchum" className='center' />
        </div>
    )
}
